import React, { ReactNode } from 'react';
import { useTheme, useMediaQuery } from '@material-ui/core';
import AuthFormContainer from 'ui/structure/AuthFormContainer/AuthFormContainer';
import SocialServices from 'ui/structure/SocialServices';
import FabTitle from 'ui/structure/FabTitle/FabTitle';
import HeaderMenu from './parts/HeaderMenu';

import styles from './AuthScreenWrapper.module.css';

import logo from 'assets/icons/sidemenus-PNG/FABLOGO.png';

export enum AuthScreenType {
  login = 'login',
}

type Props = {
  children: ReactNode;
};


const AuthScreenWrapper = ({ children }: Props) => {
  const theme = useTheme();
  const upLg1 = useMediaQuery(theme.breakpoints.up('lg1'));
  const upMd = useMediaQuery(theme.breakpoints.up('md'));
  const showServices = upMd && !upLg1; // doesn't work for between()


  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}>
        <img src={logo} alt="fab logo" className={styles.img} />
        <SocialServices />
      </div>
      <div className={styles.contentContainer}>
        {!upLg1 && <HeaderMenu />}
        <div className={styles.contentWrapper}>
          {upLg1 && <FabTitle />}

          <AuthFormContainer>{children}</AuthFormContainer>
        </div>
        {showServices && <SocialServices />}
      </div>
    </div>
  );
};

export default AuthScreenWrapper;
